import { useEffect, useState } from "react";

export default function Lightbox({
  imgItem,
  imgIndex,
  imgGrid,
  isOpen,
  onClose,
}) {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setIsVisible(true));
      });
    } else {
      setIsVisible(false);
      const timeout = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  if (!shouldRender || !imgItem.assets?.length) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col sm:flex-row items-center justify-center gap-4 p-4 transition-opacity duration-250 ease-out ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      style={{
        backgroundColor: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(20px)",
      }}
      onClick={onClose}
    >
      <img
        src={imgItem.assets[imgIndex].url}
        alt={imgItem.assets[imgIndex].fileName}
        className={`max-w-full max-h-[75vh] object-contain rounded-2xl shadow-2xl transition-all duration-300 ease-out ${
          isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
        onClick={(e) => e.stopPropagation()}
      />
      <button
        className={`absolute top-5 right-5 sm:top-6 sm:right-6 z-10 flex items-center justify-center w-10 h-10 rounded-full text-white/90 hover:text-white bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/10 transition-all duration-200 ease-out ${
          isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"
        }`}
        onClick={onClose}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      {imgGrid && (
        <div
          className="flex flex-row sm:flex-col justify-center gap-1.5 shrink-0 p-3 sm:absolute sm:top-1/2 sm:right-6 sm:-translate-y-1/2"
          onClick={(e) => e.stopPropagation()}
        >
          {imgGrid}
        </div>
      )}
    </div>
  );
}
